import { FC, useContext, useMemo } from 'react'

import { LoaderOverlay } from 'core-components/library/loader'
import { ITabProps, TabButtons } from 'core-components/library/tabButtons'
import { APLTranslationCodes } from 'onboarding/configs/translations/aplTranslationCodes'
import { LanguageContext } from 'onboarding/context/LanguageContext'

import { DocumentsHistory } from './components/documentsHistory/DocumentsHistory'
import { UploadForm } from './components/uploadForm/UploadForm'
import { useAplDocuments } from './hooks/useAplDocuments'

export const APLUploadForm: FC = () => {
  const { t } = useContext(LanguageContext)
  const { aplDocuments, lastUploadDate, fetchDocuments, isLoading } = useAplDocuments()

  const tabs = useMemo<ITabProps[]>(() => {
    return [
      {
        id: 'documents-upload-form',
        label: t(APLTranslationCodes.documents_upload_form_tab_title),
        content: () => (
          <>
            <UploadForm lastUploadDate={lastUploadDate} onSubmitFinish={fetchDocuments} />
          </>
        ),
      },
      {
        id: 'documents-history-list',
        label: t(APLTranslationCodes.document_history_tab_title),
        content: () => (
          <>
            <DocumentsHistory documents={aplDocuments} />
          </>
        ),
      },
    ]
  }, [t, lastUploadDate, aplDocuments, fetchDocuments])

  return (
    <div>
      <LoaderOverlay show={isLoading} />
      <TabButtons items={tabs} />
    </div>
  )
}

export default APLUploadForm
